import { ShieldCheck } from 'lucide-react';
import type { CSSProperties } from 'react';
import { formatarData, ou } from '../manual-utils';
import type { DocumentoMontado, PaginaDocumento } from './montar-documento';
import type { ManualData } from '../manual-types';

export function PadraoTriangulos() {
  return (
    <div className="manual-pattern" aria-hidden="true">
      {Array.from({ length: 16 }).map((_, indice) => <span key={indice} />)}
    </div>
  );
}

export function Capa({ dados }: { dados: ManualData }) {
  return (
    <article className="manual-paper manual-cover" data-pagina="capa">
      <div className="manual-cover-watermark" />
      <img className="manual-cover-logo" src="/assets/schmersal-logo.png" alt="Schmersal" />
      <PadraoTriangulos />
      <h1>{ou(dados.opcoes.tituloDocumento, 'MANUAL DE INSTRUÇÕES RECONSTITUÍDO')}</h1>
      <div className="manual-cover-machine-image">
        {dados.imagemCapa
          ? <img src={dados.imagemCapa} alt="Máquina" />
          : (
            <div className="manual-empty-image">
              <strong>Imagem da máquina</strong>
              <span>Envie a foto da máquina na etapa Identificação</span>
            </div>
          )}
      </div>
      <section className="manual-cover-bottom">
        <h2>MÁQUINA: {ou(dados.nomeMaquina, 'NOME DA MÁQUINA')}</h2>
        <table>
          <thead>
            <tr><th>CÓDIGO DE RASTREABILIDADE</th><th>VERSÃO</th><th>DATA</th></tr>
          </thead>
          <tbody>
            <tr>
              <td>{ou(dados.codigoRastreabilidade, 'CÓDIGO')}</td>
              <td>{ou(dados.versao, '0')}</td>
              <td>{formatarData(dados.dataEmissao)}</td>
            </tr>
          </tbody>
        </table>
        <PadraoTriangulos />
      </section>
    </article>
  );
}

export function PaginaMiolo({ dados, pagina, total }: {
  dados: ManualData;
  pagina: PaginaDocumento;
  total: number;
}) {
  const densidade = (dados.opcoes.densidadeTexto || 100) / 100;
  return (
    <article className="manual-paper manual-inner-page" data-pagina={pagina.numero}>
      <header className="manual-doc-header">
        <img src="/assets/schmersal-logo.png" alt="Schmersal" />
        <div>
          <strong>{ou(dados.opcoes.tituloDocumento, 'MANUAL DE INSTRUÇÕES RECONSTITUÍDO')}</strong>
          <span>Máquina: {ou(dados.nomeMaquina, 'NOME DA MÁQUINA')}</span>
        </div>
        <PadraoTriangulos />
      </header>

      <div className="manual-doc-body" style={{ '--manual-densidade': densidade } as CSSProperties}>
        {pagina.blocos.map((bloco) => (
          <div
            key={bloco.id}
            className="manual-bloco-doc"
            style={bloco.escala ? { zoom: bloco.escala * densidade } : undefined}
          >
            {bloco.conteudo}
          </div>
        ))}
      </div>

      <footer className="manual-doc-footer">
        <ShieldCheck aria-hidden="true" />
        <p>{dados.opcoes.avisoLegal}</p>
        <span>
          {ou(dados.opcoes.site, 'www.schmersal.com.br')}
          {dados.opcoes.numerarPaginas && ` | Página ${pagina.numero} de ${total}`}
        </span>
        <PadraoTriangulos />
      </footer>
    </article>
  );
}

/** Documento inteiro (capa + miolo) — usado na rolagem contínua e na impressão. */
export function DocumentoCompleto({ dados, documento }: { dados: ManualData; documento: DocumentoMontado }) {
  return (
    <>
      <Capa dados={dados} />
      {documento.paginas.map((pagina) => (
        <PaginaMiolo key={pagina.id} dados={dados} pagina={pagina} total={documento.totalPaginas} />
      ))}
    </>
  );
}
